import { Product } from '@news-mono/web-common'
import React from 'react'

export interface IconQuoteLeftProps {
    className?: string
    product?: Product
}

export const IconQuoteLeft: React.FC<IconQuoteLeftProps> = ({
    className,
    product,
}) => {
    if (product === Product.TheWest) {
        return (
            <svg
                className={className}
                viewBox="0 0 21 13"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0 12.84L2.52 0h7.32l-.9 12.84H0zm11.16 0L13.68 0H21l-.9 12.84h-8.94z"
                    fillRule="evenodd"
                />
            </svg>
        )
    }

    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 54 44"
        >
            <path d="M24.12 39.593c0 2.24-3.31 3.522-5.124 3.522C11.74 43.115 0 26.573 0 14.087 0 6.83 5.016 0 12.7 0c7.15 0 12.272 5.336 12.272 12.486 0 9.712-8.217 10.352-8.217 14.3 0 6.724 7.364 10.566 7.364 12.807zm29.026 0c0 2.24-3.308 3.522-5.122 3.522-7.257 0-18.996-16.542-18.996-29.028C29.028 6.83 34.043 0 41.728 0 48.877 0 54 5.336 54 12.486c0 9.712-8.217 10.352-8.217 14.3 0 6.724 7.363 10.566 7.363 12.807z" />
        </svg>
    )
}
